import { Component } from '@angular/core';

@Component({
  selector: 'app-skill-experience-tab',
  standalone: true,
  imports: [],
  templateUrl: './skill-experience-tab.component.html',
  styleUrl: './skill-experience-tab.component.scss'
})
export class SkillExperienceTabComponent {

}
